import {
  TyrianApp
} from './target/scala-3.6.4/grimwildonlinesheet-opt/main.js';
import('showdown');

TyrianApp.launch("myapp");
